import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import moment from 'moment-tz';
import Flatpickr, {DateTimePickerProps} from 'react-flatpickr';
import styled from 'styled-components';

import 'flatpickr/dist/themes/light.css';

interface Props
  extends Pick<
    DateTimePickerProps,
    'value' | 'onChange' | 'onClose' | 'disabled' | 'placeholder' | 'options'
  > {
  format?: string;
  className?: string;
  id?: string;
  'data-enable-time'?: boolean;
  children?: React.ReactNode;
}
export const SweetDatePicker = ({
  options = {},
  children,
  format = 'll',
  ...other
}: Props): JSX.Element => (
  <StyledContainerDiv>
    <Flatpickr
      options={{
        wrap: children != null,
        disableMobile: true,
        formatDate: (dt) => moment(dt).format(format),
        static: true,
        // @ts-expect-error Typescript requires other locale keys but it works with
        // rangeSeparator only
        locale: {
          rangeSeparator: ' - ',
        },
        ...options,
      }}
      {...other}
    >
      {children as any}
    </Flatpickr>
  </StyledContainerDiv>
);

const StyledContainerDiv = styled.div`
  flex-grow: 1;

  .flatpickr-wrapper {
    display: block;

    .flatpickr-calendar {
      background: #fff;

      &.arrowBottom {
        top: auto;
        bottom: 3em;
      }
    }

    .flatpickr-current-month {
      font-size: 100%;
    }

    .form-control[readonly]:not(:disabled) {
      background-color: #fff;
    }

    .flatpickr-day.selected {
      background-color: ${colors.selectedBg};
      border-color: ${colors.selectedBg};
    }

    .flatpickr-day.today:not(.selected),
    .flatpickr-day.prevMonthDay.today:not(.selected),
    .flatpickr-day.nextMonthDay.today:not(.selected) {
      border-bottom-color: ${colors.mediumGreen};
    }

    span.flatpickr-day.today:not(.selected):hover,
    span.flatpickr-day.prevMonthDay.today:not(.selected):hover,
    span.flatpickr-day.nextMonthDay.today:not(.selected):hover {
      border: 1px solid ${colors.mediumGreen};
    }

    .flatpickr-day.today:hover,
    .flatpickr-day.today:focus {
      border-bottom-color: ${colors.mediumGreen};
      background: ${colors.mediumGreen};
    }

    .flatpickr-day.selected,
    .flatpickr-day.startRange,
    .flatpickr-day.endRange,
    .flatpickr-day.selected.inRange,
    .flatpickr-day.startRange.inRange,
    .flatpickr-day.endRange.inRange,
    .flatpickr-day.selected:focus,
    .flatpickr-day.startRange:focus,
    .flatpickr-day.endRange:focus,
    .flatpickr-day.selected:hover,
    .flatpickr-day.startRange:hover,
    .flatpickr-day.endRange:hover,
    .flatpickr-day.selected.prevMonthDay,
    .flatpickr-day.startRange.prevMonthDay,
    .flatpickr-day.endRange.prevMonthDay,
    .flatpickr-day.selected.nextMonthDay,
    .flatpickr-day.startRange.nextMonthDay,
    .flatpickr-day.endRange.nextMonthDay {
      background: ${colors.selectedBg};
      -webkit-box-shadow: none;
      box-shadow: none;
      color: #fff;
      border-color: ${colors.selectedBg};
    }

    .flatpickr-time {
      border-radius: 0;
    }

    .flatpickr-confirm {
      font-weight: bold;
    }
  }
`;
